import { merge } from 'lodash'
import lang from './lang.js'
import React from 'react'
import config from '@/config'
import { lowercasePronounsDeep } from './utils/pronoun-case.js'

const productName = 'MeinBüro'
const productNameBookkeeping = 'WISO MeinBüro'
const customerCenterName = 'MeinBüro Portal'
const switchToBetterPlanRaiseSuccess = 'Steigere Deinen Erfolg und wechsle nun auf einen höherwertigen Plan.'

const buhlIdentPages = {
  production: 'https://www.meinbuero.de/kundencenter/steuerversand',
  prelive: 'https://www.wptest.meinbuero.de/kundencenter/steuerversand',
  test: 'https://www.wpprelive.meinbuero.de/kundencenter/steuerversand',
  development: 'https://www.wpprelive.meinbuero.de/kundencenter/steuerversand',
  local: 'https://www.wpprelive.meinbuero.de/kundencenter/steuerversand',
}

export default lowercasePronounsDeep(merge(lang, {
  companyName: 'BUHL-DATA-SERVICE GmbH',

  posthogConsentNotice: {
    text: `Hilf uns ${productName} zu verbessern. Dürfen wir technische Nutzungsdaten auswerten?`,
  },

  // account
  loginRegisterDescription: `Du hast noch kein ${productName}?`,
  // DO-13564 reworded it for the orgaMAX login only
  loginWrongPasswordOrEmailError: 'E-Mail und/oder Passwort falsch',

  avvModal: {
    cbTexts: ['Ich bestätige, dass ich zum Abschluss berechtigt bin und schließe hiermit einen ',
      'Auftragsverarbeitungsvertrag (AVV)',
      ' mit der Buhl Data Service GmbH ab.'],
  },

  // confirm email
  confirmEmailTitle: `Willkommen bei ${productName}!`,
  confirmEmailSubscription1: `Um ${productName} in vollem Umfang nutzen zu können, bestätige Deine E-Mail-Adresse:`,
  confirmEmailSubscription2: 'Bestätigungs-E-Mail erneut senden',
  confirmEmailSubscription3: 'Ich habe meine E-Mail-Adresse bestätigt',

  // subscription - selection
  subscriptionSelectionTitle: 'Paket wählen & durchstarten',
  subscriptionSelectionsubTitle: 'Wie viele aktive Kunden möchtest Du jährlich abrechnen?',
  subscriptionSelectionHintMonth: '*Funktion bald verfügbar. **Preis gilt monatlich zzgl. Umsatzsteuer, 12 Monate Mindestlaufzeit. In der Startphase sind alle Funktionen im Nutzungsumfang inbegriffen. Wir behalten uns vor, spezielle Funktionen zukünftig in kostenpflichtige Module auszulagern.',
  subscriptionSelectionHintYear: '*Funktion bald verfügbar. **Preis gilt monatlich bei jährlicher Abrechnung zzgl. Umsatzsteuer, 12 Monate Mindestlaufzeit. In der Startphase sind alle Funktionen im Nutzungsumfang inbegriffen. Wir behalten uns vor, spezielle Funktionen zukünftig in kostenpflichtige Module auszulagern.',
  subscriptionSelectionHintMonthGMI: '*Preis gilt monatlich zzgl. Umsatzsteuer, monatlich kündbar.',

  // active customer
  activeCustomerTitle: 'Aktive Kunden',
  activeCustomerErrorMessage: 'Beim Laden der aktiven Kunden ist ein Fehler aufgetreten',

  // settings - document export

  // settings - shops
  shopSettingsDescription1: 'Verknüpfe MeinBüro mit Webshops, um Daten auszutauschen.',

  // settings - carrier accounts
  carrierAccountsCreateSuccessMessage: 'Carrier Account created with success.',
  carrierAccountsSaveSuccessMessage: 'Carrier Account updated with success.',
  carrierAccountsDeleteSuccessMessage: 'Carrier Account was deleted.',

  // upgrade
  upgradeSubscriptionSepaHint: 'Mit Klick auf "Vertrag abschließen und Wechsel durchführen" ermächtige ich die Buhl Data Service GmbH, Zahlungen von meinem Konto mittels SEPA-Lastschrift einzuziehen. Zugleich weise ich mein Kreditinstitut an, die von Ihnen auf mein Konto gezogenen Lastschriften einzulösen. Ich kann innerhalb von 8 Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrags verlangen. Dabei gelten die mit meinem Kreditinstitut vereinbarten Bedingungen. Gläubiger-Identifikationsnummer der Buhl Data Service GmbH: DE23BSC00000051644.',
  upgradeSubscriptionPricingAndOfferHint: '* Alle Preise sind netto zzgl. USt.. Das Angebot richtet sich nur an Unternehmer (§ 14 BGB) und nicht an Verbraucher (§ 13 BGB).',

  // subscription - trial
  subscriptionModal: {
    text: 'Digitalisiere wichtige Geschäftsbereiche und spare somit wertvolle Zeit im Büro, die du in dein Kerngeschäft investieren kannst.',
    subscriptionType: {
      types: {
        main: {
          trialSelectBulletPoints: [
            'Auftragswesen, Online-Banking und vorbereitende Buchhaltung finanzamtkonform und rechtssicher erledigen',
            'Steuerrelevante Unterlagen zur weiteren Bearbeitung bequem und sicher an Deinen Steuerberater übermitteln',
            'Anwendung im Browser oder per App öffnen und so jederzeit und von überall auf Dein Unternehmen zugreifen',
            '',
            '',
          ],
          trialSelectTabSummary: 'Auftragswesen, Banking und vorbereitende Buchhaltung, DATEV-Schnittstelle, Steuerberaterzugang.',
        },
        document: {
          trialSelectBulletPoints: [
            'Dokumente und Belege schnell und einfach digitalisieren und hochladen, z.B. per mobiler Scan-App (iOS & Android)',
            'Sichere Ablage Deiner digitalen Dokumente und Belege auf unseren mehrfach geschützten Servern in Deutschland',
            'Gesuchte Informationen dank Volltextsuche, Tags und Ordnern schnell und mühelos finden',
            'Rechnungen online bezahlen und relevante Unterlagen digital zur Weiterverarbeitung an Deinen Steuerberater senden',
            '',
          ],
          trialSelectTabSummary: 'Dokumente & Belege digitalisieren und sicher online aufbewahren. Mit Steuerberaterzugang und Texterkennung.',
        },
        staff: {
          trialSelectBulletPoints: [
            'Intuitive, digitale Arbeitszeiterfassung für jede Branche – bald Pflicht für jeden Arbeitgeber',
            'Alle Daten zur Lohnbuchhaltung vorbereiten und dadurch Kosten und Zeit bei Deinem Lohnbuchhalter einsparen',
            'Digitale Personalakte anlegen und verwalten, Dokumente zuordnen und Stammdaten pflegen',
            '',
            '',
          ],
          trialSelectTabSummary: 'Digitale Personalakte: Stammdaten, Arbeitszeiten, An- und Abwesenheiten, vorbereitende Lohnbuchhaltung.',
        },
      },
    },
  },

  // limitation messages
  limitations: {
    customerCount: {
      title: 'Anzahl der aktiven Kunden erreicht',
      description: 'Herzlichen Glückwunsch! Du hast die Anzahl der aktiven Kunden Deines Paketes erreicht. Steigere Deinen Erfolg und wechsle nun in ein höherwertiges Paket',
    },
    documentScanCount: {
      subTitle: `Du hast das Limit Deines Plans erreicht. ${switchToBetterPlanRaiseSuccess}`,
      texts: ['So erreichst Du uns:', 'Mo. – Fr. 08:00 – 17:00 Uhr unter'],
    },
    documentScanCountInfo: {
      texts: ['So erreichst Du uns:', 'Mo. – Fr. 08:00 – 17:00 Uhr unter'],
    },
    storageSpace: {
      subTitle: 'In Deinem aktuellen Plan ist Dein Speicherkontingent aufgebraucht. Verschaffe Dir durch ein Upgrade mehr Speicherplatz!',
      texts: ['So erreichst Du uns:', 'Mo. – Fr. 08:00 – 17:00 Uhr unter'],
    },
    storageSpaceInfo: {
      texts: ['So erreichst Du uns:', 'Mo. – Fr. 08:00 – 17:00 Uhr unter'],
    },
    documentCount: {
      texts: ['So erreichst Du uns:', 'Mo. – Fr. 08:00 – 17:00 Uhr unter'],
    },
    documentCountInfo: {
      texts: ['So erreichst Du uns:', 'Mo. – Fr. 08:00 – 17:00 Uhr unter'],
    },
  },

  // limitations
  maxCustomerReachedErrorMessage: 'Du hast die maximale Anzahl an aktiven Kunden erreicht.',

  // documents and gmi
  documentSubscriptionSubTile: 'Hole Dir jetzt das Modul Belege und optimiere Deine Rechnungsverwaltung!',
  documentTitleSlogan: 'Belege automatisiert im Überblick haben',
  documentSetupInfoCallToActionText: ['Nach 14 Tagen wird Deine Testphase automatisch beendet.'],
  documentSetupTexts:
    [
      'Rechnungen & Kontoauszüge automatisch aus über 5.000 Online-Portalen importieren',
      'Rechnungsimport aus E-Mail-Postfächern',
      'Scannen von Papierbelegen',
      'Alle wichtigen Dokumente im Überblick',
      'Belege sofort verschiedenen Ausgaben zuordnen',
    ],

  // onboarding
  onboarding: {
    ...lang.onboarding,
    welcome: {
      ...lang.onboarding.welcome,
    },
    business: {
      ...lang.onboarding.business,
    },
    teamwork: {
      ...lang.onboarding.teamwork,
    },
    vatChoice: {
      ...lang.onboarding.vatChoice,
    },
    search: {
      label: 'Branche*',
    },
  },

  // dashboard

  dashboard: {
    taxConsultantPlaceholder: {
      heading: 'Steuere aus der Ferne die Prozesse Deiner Mandanten',
      paragraph: {
        one: 'Du hast Fragen zur Nutzung von MeinBüro Kanzlei? Kein Problem, wir stehen Dir gerne zur Seite und beantworten Deine Fragen.',
        two: 'Schreibe uns eine E-Mail, oder vereinbare gleich einen für Dich passenden Rückruftermin.',
      },
      contactEmail: 'kanzlei@buhl.de',
      contactEmailSubject: 'Fragen zu MeinBüro Kanzlei',
    },
    personalTutorial: {
      right: {
        title: 'Erste Schritte in WISO MeinBüro Personal',
      },
      description: 'Unser Handbuch kann unter folgendem Link aufgerufen werden:',
      manual: 'WISO MeinBüro Personal Handbuch',
      actions: {
        open: 'Personal starten',
      },
    },
  },
  onboardingV2: {
    general: {
      success: 'Erfolgreich eingerichtet',
    },
    user: {
      title: 'Herzlich willkommen!',
      texts: {
        main: 'Die folgenden Angaben werden zur Einrichtung Deines Briefpapiers verwendet.',
        document: 'Die folgenden Angaben werden zur Einrichtung Deines Kontos verwendet.',
        staff: 'Die folgenden Angaben werden zur Einrichtung Deines Unternehmens verwendet.',
        default: 'Die folgenden Angaben werden zur Einrichtung Deines Kontos verwendet.',
      },
      companyNameTooltip: 'Gib hier Deinen Firmennamen ein. Bist Du Freiberufler oder handelt es sich um ein Kleingewerbe oder Einzelunternehmen, trage Deinen Namen und Geschäftsbezeichnung, falls vorhanden, ein.',
      inputs: {
        companyName: 'Unternehmen*',
        companyNamePlaceholder: 'Name des Unternehmens',
        firstNamePlaceholder: 'Max',
        lastName: 'Nachname*',
        lastNamePlaceholder: 'Mustermann',
        phone: 'Telefonnummer*',
        phonePlaceholder: '0170 1234567',
      },
    },
    companyAddress: {
      title: ({ companyName }) => `${companyName}`,
      text: 'Um die Einrichtung Deiner Firma abzuschließen,<br />benötigen wir nur noch die folgenden Angaben.',
    },
    mboLastScreen: {
      title: 'Einrichtung erfolgreich abgeschlossen',
      description1: 'Ab sofort kannst Du mit WISO MeinBüro Deinen Büroalltag vereinfachen.',
      description2: 'Solltest Du Fragen oder Anmerkungen haben, unterstützen wir Dich gerne über das integrierte Hilfecenter oder telefonisch unter 02735 776 65001 (Mo - Fr: 08:00 – 17:00 Uhr).',
      personHeader: 'Viel Erfolg wünschen Dir',
      personDescription: 'Laura & das Team von WISO MeinBüro',

    },
    avv: {
      title: 'Vereinbarung zur Auftragsverarbeitung',
      text: 'Mit WISO MeinBüro verwaltest Du personenbezogene Daten Deiner Interessenten, Kunden und Mitarbeiter. Gemäß Datenschutzgrundverordnung (DSGVO) ist dazu der Abschluss einer Vereinbarung zur Auftragsverarbeitung erforderlich. Durch diesen sind die Rechte und Pflichten beider Parteien gemäß Art. 28 DSGVO geregelt und Du kannst Dich darauf verlassen, dass die Buhl Data Service GmbH Deine uns anvertrauten Daten sicher verarbeitet.',
      description: `Bei der Nutzung von WISO MeinBüro gelten unsere <a href=${config.agbUrl} target='_blank'>AGB</a> und die <a href=${config.privacyUrl} target='_blank'>Datenschutzerklärung</a>`,
      description2: 'Die Verarbeitung von personenbezogenen Daten Deiner Interessenten und Kunden auf den Servern der Buhl Data Service GmbH erfordert laut Artikel 28 DSGVO den Abschluss einer Vereinbarung zur Auftragsverarbeitung.',
      texts: {
        avvText: (avv) => <>{ avv } mit der Buhl Data Service GmbH abschließen</>,
        avv: 'Vereinbarung zur Auftragsverarbeitung (AVV)',
      },
    },
    business: {
      labelTax: 'Hinweis: Die Versteuerungsart lässt sich auch nachträglich in den Einstellungen ändern.',
    },
    taxConsultantUser: {
      text: 'Bitte nenne uns den Ansprechpartner für MeinBüro Kanzlei. Dies kann entweder der Kanzleiinhaber oder ein verantwortlicher Mitarbeiter sein. Du kannst später weitere Ansprechpartner hinzufügen.',
    },
    taxConsultantCompanyAddress: {
      title: 'Kanzleistammdaten',
      text: 'Bitte trage Deine Kanzleistammdaten ein, um eine reibungslose Identifikation durch Deine Mandanten zu ermöglichen.',
    },
    password: {
      title: 'Lass uns einige Sicherheitsmaßnahmen einrichten',
      text: 'So kannst Du einfach und sicher auf Dein Konto zugreifen',
    },
  },

  onboardingTesterData: {
    startModal: {
      leftDescription: 'Mit WISO MeinBüro schreibst Du Rechnungen, Angebote und weitere Geschäftsvorgänge mühelos.',
    },
  },

  taxForms: {
    forms: {
      base: {
        notVerifiedErrorTitle: 'Identifizierung erforderlich',
        notVerifiedErrorMessage: `Da Deine Umsatzsteuer-Voranmeldung ohne eigenes ELSTER-Zertifikat übermittelt wird, ist eine Identifizierung notwendig. So wird sichergestellt, dass die Übermittlung eindeutig Dir zugeordnet werden kann und rechtskonform erfolgt.
</br></br>
Bitte identifiziere Dich im buhl:Kundencenter. Dir stehen mehrere Möglichkeiten zur Verfügung, die Du online innerhalb weniger Minuten durchführen kannst.
</br></br>
Nach erfolgter Verifikation kannst Du die Umsatzsteuer-Voranmeldung versenden.`,
        notVerifiedPrimaryButtonLabel: 'Verifikation starten',
        notVerifiedPrimaryButtonUrl: buhlIdentPages[ENV.releaseStage],
        notVerifiedSecondaryButtonLabel: 'Mehr Informationen',
        notVerifiedSecondaryButtonUrl: 'https://www.buhl.de/go/46139',
      },
    },
  },

  // settings
  settings: {
    user: {
      manageBuhlAccount: 'buhl:Konto verwalten',
      goToBuhlAccount: 'Zum buhl:Konto',
      buhlAccountDescription: 'Alle Einstellungen rund um Dein buhl:Konto kannst Du im Kundencenter vornehmen. Dort findest Du die Möglichkeit Dein Passwort oder Deine E-Mail-Adresse zu ändern.',
    },
    jumpMarks: {
      customerLogo: {
        headline: `Logo für das ${customerCenterName}`,
        text: `Hier kannst Du Dein Logo für das ${customerCenterName} hochladen und aktivieren.`,
      },
      contactInfo: {
        text: `Gib hier die E-Mail-Adresse und Telefonnummer an, die im ${customerCenterName} als Kontaktmöglichkeit für Deine Kunden verwendet werden soll.`,
      },
      documentsUpload: {
        text: `AGB, Widerrufsbelehrung, Preislisten, Werbeflyer direkt im ${customerCenterName} zur Verfügung stellen.`,
      },
    },
    account: {
      customerCenterTooltipTitle: `${customerCenterName} kurz erklärt`,
      customerCenterTooltipDesc: `Durch das ${customerCenterName} bietest Du Deinen Kunden die Möglichkeit, ihre Angebote, Aufträge und Rechnungen direkt online einzusehen und mit den Vorgängen zu interagieren – von der Angebotsannahme bis zur direkten Weiterverarbeitung zum Auftrag.</br></br>Aufträge und Rechnungen können direkt über das Mobiltelefon beglichen werden, und das mit nur wenigen Klicks. Digitalisiere Deine Prozesse und schone die Umwelt, indem Du auf das Drucken verzichtest.</br></br>Aber wie funktioniert das? Ganz einfach: Du versendest das Angebot, den Auftrag und die Rechnung einfach per E-Mail, und das ${customerCenterName} steht Deinen Kunden als direkter Link in der E-Mail zur Verfügung.</br></br>Die Einstellungsmöglichkeiten findest Du <a href="/settings/customer-center">hier</a>.`,
      paymentMethodDescriptionBegin: 'Gib Deinen Kunden die Möglichkeit, Aufträge oder Rechnungen direkt in Deinem ',
      paymentMethodDescriptionEnd: ' unkompliziert und zügig zu begleichen – und das zu jeder Zeit und an jedem Ort.',
    },
    pageTitles: {
      customerCenter: customerCenterName,
    },
    paused: {
      title: 'Pausierter Vertrag',
      paragraphs: [
        'Dein Vertrag wurde aufgrund von Unstimmigkeiten pausiert.',
        'Bitte wende Dich an unsere Kundenbetreuung, um den genauen Grund zu erfahren und die Reaktivierung einzuleiten.',
        'Hast Du Deine letzte Rechnung für WISO MeinBüro noch nicht vollständig gezahlt? Auch dann wird Dein Vertrag nach einiger Zeit pausiert. Erteile uns in Deinem Kundenkonto doch ganz einfach eine Einzugsermächtigung, damit dies nicht mehr passiert: <a href="https://www.buhl.de/shop/zahlungsdaten" target="_blank" rel="noopener">Zum Kundenkonto >></a>',
        'Du erreichst uns Montag bis Freitag von 9 – 21 Uhr und Samstag von 9 – 13 Uhr unter der Telefon-Nr. 02735 / 90 96 99 oder über unser <a href="https://www.buhl.de/shop/anfrage-stellen" target="_blank" >Kontaktformular</a>.',
      ],
      buttonLabel: 'Lesemodus',
    },
  },

  oldPlanModal: {
    text: `Seit dem 10.11.2021 gibt es neue Pläne von WISO MeinBüro Web.</br>Eine Änderung Deines Plans ist mit einem Wechseln in das neue Preismodell möglich.</br></br><b>So geht’s:</b></br>
     Wir erledigen es gerne für Dich.</br>Du erreichst uns unter 02735 776 65001 (Mo. bis Fr.: 8-17 Uhr).</br>Alternativ erreichst Du uns auch per E-Mail: <a href="mailto:meinbuero@buhl.de">meinbuero@buhl.de</a>`,
  },

  // subscription - details
  subscriptionDetails: {
    yourPlan: (billingData) => `Dein Plan ${billingData?.store?.type === 'web' && billingData?.store?.subscriptionId ? ' (' + billingData?.store?.subscriptionId + ')' : ''}`,
  },

  footer: {
    trialWithDiscountText: (remainingDays) => `Testphase endet in ${remainingDays} Tag${remainingDays === 1 ? '' : 'en'}. Jetzt kaufen >`,
  },

  myAccount: {
    banner: {
      trial: {
        description: 'Wähle jetzt einen Plan aus und starte direkt mit WISO MeinBüro durch.',
      },
    },
    getSubscriptionTitle: (title) => `WISO MeinBüro (${title})`,
    documentTrialModal: {
      title: 'Dokumente digital organisieren',
      subTitle: `Erweitere ${productNameBookkeeping} um ein leistungsstarkes Dokumentenmanagement:`,
      bulletPoints: [
        { icon: 'check', text: '', subText: 'Papierdokumente per App (iOS & Android) digitalisieren' },
        { icon: 'check', text: '', subText: 'Dokumente automatisch aus E-Mails & Portalen importieren' },
        { icon: 'check', text: '', subText: 'Dokumente dank Volltextsuche, Ordnern und Tags schnell finden' },
        { icon: 'check', text: '', subText: 'Sicher im GoBD-konformen Dokumentenarchiv ablegen' },
        { icon: 'check', text: '', subText: 'Nahtlos mit dem Steuerberater zusammenarbeiten' },
      ],
      confirmButtonLabel: 'Jetzt kostenlos testen',
      cancelButtonLabel: 'Später',
    },
    subscriptionDetails: {
      daysCountdown: (countDown) => `${countDown} Tage verbleibend`,
      billingDataTitle: 'buhl:Konto verwalten',
    },
    subscriptionUpgrade: {
      buyPlan: 'Jetzt kaufen',
    },
  },

  account: {
    deletion: {
      deletionInformationWindows: `Achtung! Mit Löschung Deines Accounts werden alle bereits vorhandenen Dokumente und Belege gelöscht, es ist nicht mehr möglich diese über die Freigabe im ${customerCenterName} aufzurufen. Des Weiteren sind die aus Deinem Windows Produkt verbundenen und hochgeladenen Dokumente ebenfalls gelöscht und nicht mehr abrufbar.`,
    },
  },

  tenantLogoSettings: {
    shareHub: {
      title: `${customerCenterName} einrichten`,
      description: `Nutze die Vorteile des ${customerCenterName}s - mehr Zeit - weniger Kosten - ökologischen Fußabdruck verringern.`,
      explanationTitle: `${customerCenterName} kurz erklärt`,
      explanationDescription1: `Mit dem ${customerCenterName} kannst Du bequem Dokumente, Belege, Rechnungen, Angebote, Aufträge etc. digital teilen. In dem ${customerCenterName} stehen dem Empfänger dann verschiedene Möglichkeiten zur Ansicht zur Verfügung.`,
      explanationDescription2: 'Es bietet zudem die Möglichkeit, mit dem Empfänger zu interagieren. Dazu gehören die Angebotsannahme, die elektronische Unterschrift und direkte Bezahlmöglichkeiten. Dies erleichtert die Kommunikation und Abwicklung Deiner Geschäftsprozesse erheblich.',
    },
    customerCenter: {
      description: `Lade Dein Logo hoch, um es im ${customerCenterName} anzuzeigen und somit Dein ${customerCenterName} zu individualisieren. Ist bereits ein E-Mail-Logo hochgeladen, wird es hier angezeigt.`,
      title: `Logo für das ${customerCenterName}`,
    },
    customerCenterLabel: customerCenterName,
    logo: {
      customerCenterToggleActivationMessage: `Das Logo wurde für das ${customerCenterName} aktiviert`,
      customerCenterToggleDeactivationMessage: `Das Logo wurde für das ${customerCenterName} deaktiviert`,
    },
  },

  customerCenterSettings: {
    documentsUpload: {
      subText: `Du kannst Deinen Kunden AGB, Widerrufsbelehrung für Verbraucher oder einfach eine Preisliste im ${customerCenterName} zum Download zur Verfügung stellen. Vergib einen aussagekräftigen Namen für das Dokument z. B. AGB und lade es hoch, es steht dann automatisch im ${customerCenterName} zur Verfügung.`,
    },
  },

  documents: {
    enableSharing: `Du kannst dieses Dokument im ${customerCenterName} zur Ansicht freigeben.
    Mit Klick wird der Link zur Freigabe in den Zwischenspeicher gelegt.
    Des Weiteren ist es möglich diese Freigabe direkt via E-Mail zu senden.
    Die Freigabe kann jederzeit wieder entzogen werden.`,
    sharingNotAllowed: 'Nur PDF Dateien können freigegeben werden.',
    disableSharing: 'Freigabe beenden',
    isShared: 'Dokument ist freigegeben.',
    isAssignedToWindows: 'Das Dokument kann nur in WISO MeinBüro Desktop bearbeitet werden.',
    erpDeleteError: (num) => (num === 1 ? 'Das Dokument' : 'Mindestens eins der Dokumente') + ' ist mit MeinBüro Desktop verknüpft und kann nur dort gelöscht werden.',
    folder: {
      systemFolderNoChildren: 'Der Ordner konnte nicht erstellt werden. Du befindest Dich im MeinBüro Portal Systemordner und kannst keine weiteren Unterordner erstellen. Bitte wechsle zu Home um einen neuen Ordner zu erstellen.',
    },
    shareHUBFolderDesc: `Im ${customerCenterName} Systemordner werden alle Vorgangsbelege automatisch abgelegt, die Du in WISO MeinBüro Desktop per E-Mail versendest. Vorausgesetzt wird, dass Du ${customerCenterName} eingerichtet und für den jeweiligen Vorgang, wie z. B. Angebot oder Rechnung, aktiviert hast.`,
  },

  signature: {
    moduleModal: {
      text1: (type) => `Deine ${type} elektronisch und nachweisbar\nvon Deinen Kunden unterschreiben lassen - Druckkosten und Zeit einsparen.`,
      text3: 'So erreichst Du uns\nMo. - Fr. 08:00 Uhr - 17:00 Uhr unter',
      telephone: '02735 6474-103',
      email: {
        emailId: 'beratung@meinbuero.de',
        body: 'Hi MeinBüro Team,\n\nich habe Interesse an der elektronischen Unterschrift.',
      },
    },
  },

  modals: {
    passwordPromptModal: {
      description: 'Bitte gib hier Dein buhl:Konto Passwort ein.',
    },
  },
  appDeviceModal: {
    mainAndDocument: {
      visit: `Um ${productNameBookkeeping} und WISO MeinBüro Dokumente optimal nutzen zu können, besuche <b>app.meinbuero.de</b> an einem Computer oder Laptop.`,
      download: 'Möchtest Du die Anwendung auf Deinem Smartphone verwenden? Dann lade einfach die passende App herunter.',
    },
    main: {
      visit: `Um ${productNameBookkeeping} optimal nutzen zu können, besuche <b>app.meinbuero.de</b> an einem Computer oder Laptop.`,
      download: 'Möchtest Du die Anwendung auf Deinem Smartphone verwenden? Dann lade einfach die passende App herunter.',
    },
    document: {
      visit: 'Um WISO MeinBüro Dokumente optimal nutzen zu können, besuche <b>app.meinbuero.de</b> an einem Computer oder Laptop.',
      download: 'Möchtest Du die Anwendung auf Deinem Smartphone verwenden? Dann lade einfach die passende App herunter.',
    },
    staff: {
      visit: 'Um WISO MeinBüro Personal optimal nutzen zu können, besuche <b>app.meinbuero.de</b> auf einem Computer oder Laptop.',
    },
    productTitles: {
      main: productNameBookkeeping,
      document: 'WISO MeinBüro Dokumente',
      personal: 'WISO MeinBüro Personal',
    },
  },

  // tax categories
  generalTaxCategoryDescriptionOption1: '§ Bei der Soll-Besteuerung wird die Umsatzsteuer anhand des Rechnungsdatums bei Erstellung fällig.',
  generalTaxCategoryDescriptionOption2: '§ Bei der Ist-Besteuerung wird die Umsatzsteuer anhand des tatsächlichen Zahlungseingangs fällig.',
  generalTaxCategoryDescriptionOption3: '§ Als Kleinunternehmer im Sinne von §19 UStG wird keine Umsatzsteuer berechnet.',

  backup: {
    ...lang.backup,
  },
  marketing: {
    main: {
      description: 'Erledige Dein komplettes Auftragswesen und die vorbereitende Buchhaltung mit wenigen Klicks - inklusive App (iOS & Android).',
    },
    document: {
      description: 'Digitalisiere, organisiere und archiviere Dokumente bequem zu jeder Zeit und von überall - inklusive App (iOS & Android).',
    },
    staff: {
      description: 'Erledige Personalprozesse sicher digital - von der Personalakte über Urlaubsplanungen bis hin zu Reisekostenabrechnungen.',
    },
  },

  moduleSubscription: {
    list: {
      allProducts: 'Alle Produkte',
    },
  },
  article: {
    list: {
      listEmptyStateTitle: 'Keine Artikel vorhanden',
      listEmptyStateSubtitle: 'Jetzt den ersten Artikel anlegen',
    },
  },
  supplier: {
    list: {
      supplierListEmptyStateTitle: 'Keine Lieferanten vorhanden',
      listEmptyStateSubtitle: 'Jetzt den ersten Lieferanten anlegen',
    },
  },
  customer: {
    list: {
      customerListEmptyStateTitle: 'Keine Kunden vorhanden',
      listEmptyStateSubtitle: 'Jetzt den ersten Kunden anlegen',
    },
  },

  firstSteps: {
    welcome: {
      headline: 'Willkommen bei WISO MeinBüro!',
      testDaysRemaining: (remainingDays) => `Du kannst ${productNameBookkeeping} noch ${remainingDays} Tage testen.`,
      trialExpired: `Deine ${productNameBookkeeping} Testphase ist abgelaufen.`,
    },
    infoBoxes: {
      support: {
        title: 'Hilfe-Center',
        description: 'Alles dabei: interaktive Tutorials, Videos, News & mehr',
      },
      consultation: {
        description: 'Mo-Fr von 8 bis 17 Uhr',
        tel: '02735 6474-103',
      },
      webinars: {
        title: 'Handbuch',
        secureSpots: 'Handbuch öffnen',
        description: 'Anleitungen und Tipps zu WISO MeinBüro',
      },
    },
    dataSelection: {
      ownDataDescription: 'Für produktive Arbeit mit echten Unternehmensdaten (z. B. fortlaufende Rechnungsnummern, eigenes Briefpapier)',
      demoDataDescription: 'Für das Testen mit vorbereiteten Demo-Daten in einem separaten Bereich - jederzeit zurücksetzbar',
      ownDataTitle: 'Echte Buchhaltung im Live-Modus',
      ownDataButton: 'Mit eigenen Daten arbeiten',
      demoDataTitle: 'Ausprobieren im Demo-Modus',
      demoDataButton: 'Im Demo-Modus testen',
      infoText: 'Du kannst jederzeit zwischen dem Live-Modus und dem Demo-Modus wechseln.',
      infoText2: 'Daten lassen sich NICHT zwischen den beiden Modi übertragen.',
      infoText3: 'Im Live-Modus gibt es KEINEN Reset (auch nach der Testphase) – viele, aber nicht alle Datensätze lassen sich nur manuell löschen. Den Demo-Modus kannst du immer zurücksetzen.',
    },
  },
}))
